import get from 'lodash/get';
import moment from 'moment';
import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@material-ui/core/Tooltip';


const RelativeDateField = ({ source, record = {} }) => {
  const value = get(record, source);
  return (
    <Tooltip title={value && moment(value).format('dddd, MMMM Do YYYY, h:mm:ss a')}>
      <span>
        {value && moment(value).fromNow()}
      </span>
    </Tooltip>
  );
};


RelativeDateField.propTypes = {
  record: PropTypes.shape({}),
  source: PropTypes.string.isRequired,
};


RelativeDateField.defaultProps = {
  record: undefined,
};


export default RelativeDateField;



// WEBPACK FOOTER //
// ./src/components/RelativeDateField.js